import { useCallback } from "react";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";
import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import { SearchByDetailLayout } from "../../../_shared";

import type * as Model from "../../model";

type Props = {
	searchModel: Model.Type.SearchModel;

	// 詳細検索のフリーワードテキストの変更（空白区切り）
	onChangeFreeWordText: (value: string) => void;
	// 詳細検索のアクティブな予約フラグの変更
	onChangeIsActiveChecked: (value: boolean) => void;
	// 詳細検索のキャンセル済みフラグの変更
	onChangeIsCanceledChecked: (value: boolean) => void;
	// 詳細検索のメルマガ配信希望者フラグの変更
	onChangeIsAcceptMailMagazineChecked: (value: boolean) => void;
	// 詳細検索の現地決済者フラグの変更
	onChangeIsLocalPaymentChecked: (value: boolean) => void;
	// 詳細検索の直接入力した予約フラグの変更
	onChangeIsHostReservationChecked: (value: boolean) => void;
	// 詳細検索の日帰り予約フラグの変更
	onChangeIsDayTripChecked: (value: boolean) => void;
};

export const SearchByDetailConditionsComposition = ({
	searchModel,
	//
	// 詳細検索のフリーワードテキストの変更（空白区切り）
	onChangeFreeWordText,
	// 詳細検索のアクティブな予約フラグの変更
	onChangeIsActiveChecked,
	// 詳細検索のキャンセル済みフラグの変更
	onChangeIsCanceledChecked,
	// 詳細検索のメルマガ配信希望者フラグの変更
	onChangeIsAcceptMailMagazineChecked,
	// 詳細検索の現地決済者フラグの変更
	onChangeIsLocalPaymentChecked,
	// 詳細検索の直接入力した予約フラグの変更
	onChangeIsHostReservationChecked,
	// 詳細検索の日帰り予約フラグの変更
	onChangeIsDayTripChecked,
}: Props) => {
	/**
	 * 詳細検索のフリーワードテキストの変更（空白区切り）
	 */
	const handleChangeFreeWordText = useCallback(
		(value: string) => {
			onChangeFreeWordText(value);
		},
		[onChangeFreeWordText],
	);
	/**
	 * 詳細検索のアクティブな予約フラグの変更
	 */
	const handleChangeIsActiveChecked = useCallback(
		(value: boolean) => {
			onChangeIsActiveChecked(value);
		},
		[onChangeIsActiveChecked],
	);
	/**
	 * 詳細検索のキャンセル済みフラグの変更
	 */
	const handleChangeIsCanceledChecked = useCallback(
		(value: boolean) => {
			onChangeIsCanceledChecked(value);
		},
		[onChangeIsCanceledChecked],
	);
	/**
	 * 詳細検索のメルマガ配信希望者フラグの変更
	 */
	const handleChangeIsAcceptMailMagazineChecked = useCallback(
		(value: boolean) => {
			onChangeIsAcceptMailMagazineChecked(value);
		},
		[onChangeIsAcceptMailMagazineChecked],
	);
	/**
	 * 詳細検索の現地決済者フラグの変更
	 */
	const handleChangeIsLocalPaymentChecked = useCallback(
		(value: boolean) => {
			onChangeIsLocalPaymentChecked(value);
		},
		[onChangeIsLocalPaymentChecked],
	);
	/**
	 * 詳細検索の直接入力した予約フラグの変更
	 */
	const handleChangeIsHostReservationChecked = useCallback(
		(value: boolean) => {
			onChangeIsHostReservationChecked(value);
		},
		[onChangeIsHostReservationChecked],
	);
	/**
	 * 詳細検索の日帰り予約フラグの変更
	 */
	const handleChangeIsDayTripChecked = useCallback(
		(value: boolean) => {
			onChangeIsDayTripChecked(value);
		},
		[onChangeIsDayTripChecked],
	);

	return (
		<div className="space-y-2">
			{/* フリーワード */}
			<div className="space-y-1">
				<p className="text-sm">フリーワード検索</p>

				<InputTextField
					type="text"
					value={searchModel.freeWordText}
					placeholder="予約番号 氏名 ...etc（空白区切り）"
					handleChange={handleChangeFreeWordText}
				/>
			</div>

			<SearchByDetailLayout>
				{/* アクティブな予約 */}
				<CheckboxField
					value={searchModel.isActiveChecked}
					label="アクティブな予約を表示"
					handleChange={handleChangeIsActiveChecked}
				/>

				{/* キャンセル済みの予約 */}
				<CheckboxField
					value={searchModel.isCanceledChecked}
					label="キャンセル済みの予約を表示"
					handleChange={handleChangeIsCanceledChecked}
				/>

				{/* メルマガ配信希望の予約 */}
				<CheckboxField
					value={searchModel.isAcceptMailMagazineChecked}
					label="メルマガ配信希望の予約を表示"
					handleChange={handleChangeIsAcceptMailMagazineChecked}
				/>

				{/* 現地決済者の予約 */}
				<CheckboxField
					value={searchModel.isLocalPaymentChecked}
					label="現地決済者の予約を表示"
					handleChange={handleChangeIsLocalPaymentChecked}
				/>

				{/* 直接入力した予約（ホストが入力） */}
				<CheckboxField
					value={searchModel.isHostReservationChecked}
					label="直接入力した予約を表示"
					handleChange={handleChangeIsHostReservationChecked}
				/>

				{/* 日帰り予約 */}
				<CheckboxField
					value={searchModel.isDayTripChecked}
					label="日帰り予約を表示"
					handleChange={handleChangeIsDayTripChecked}
				/>
			</SearchByDetailLayout>
		</div>
	);
};
